export const showZoomLevel = () => ({
    type: 'SHOW_ZOOM_LEVEL',
   })
  
export const hideZoomLevel = () => ({
      type: 'HIDE_ZOOM_LEVEL',
   })